import React from 'react';
import { Box, keyframes } from '@mui/material';

// Floating circles animation
const floatCircles = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.6; }
  33% { transform: translate(10px, -5px) scale(1.1); opacity: 0.8; }
  66% { transform: translate(-5px, 5px) scale(0.9); opacity: 0.4; }
`;

const HighlightCard = ({ children, sx = {}, ...props }) => {
  return (
    <Box 
      sx={{ 
        position: 'relative',
        display: 'flex', 
        alignItems: 'flex-start', 
        gap: 1.5, 
        mt: 2,
        p: 3,
        borderRadius: '12px',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
        border: '1px solid #e9ecef',
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.08)',
        ...sx
      }}
      {...props}
    >
      {/* Floating circles */}
      <Box sx={{
        position: 'absolute',
        top: -5,
        left: 20,
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
        animation: `${floatCircles} 3s ease-in-out infinite`
      }} />
      <Box sx={{
        position: 'absolute',
        top: 15,
        right: 30,
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        animation: `${floatCircles} 4s ease-in-out infinite 1s`
      }} />
      <Box sx={{
        position: 'absolute',
        bottom: 5,
        left: 60,
        width: 4,
        height: 4,
        borderRadius: '50%',
        backgroundColor: 'rgba(0, 0, 0, 0.18)',
        animation: `${floatCircles} 2.5s ease-in-out infinite 0.5s`
      }} />
      
      {children}
    </Box>
  );
};

export default HighlightCard;